import configurationsQuarterEndRoute from './configurations-quarter-end-route'

export default () => [
  configurationsQuarterEndRoute(),
]
